module.exports = __webpack_public_path__ + "img/40.4cce5e17.jpg";